import { NavArrowLeft } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from '../Icon.types';

const ArrowLeftIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <NavArrowLeft width={size} height={size} color={color} {...rest} />;

ArrowLeftIcon.displayName = 'ArrowLeftIcon';

export default ArrowLeftIcon;
